/**
 * 定义了接口返回的相关的状态
 */

export const subscription = {

    /**
     * 等待第一次支付
     */
    PENDING_PATMENT: 'pending_payment',

    /**
     * 等待生效
     */
    ACTIVATING: 'activating',

    /**
     * 正在执行过期处理
     */
    DEACTIVATING: 'deactivating',

    /**
     * 生效中
     */
    ACTIVE: 'active',

    /**
     * 已失效
     */
    INACTIVE: 'inactive'

};

export const payment = {

    /**
     * 等待支付
     */
    PENDING: 'pending',

    /**
     * 支付处理中
     */
    PROCESSING: 'processing',

    /**
     * 已支付
     */
    COMPLETED: 'completed',

    /**
     * 退款中
     */
    REFUNDING: 'refunding',

    /**
     * 人工退款中
     */
    MANUAL_REFUNDING: 'manual_refunding',

    /**
     * 已退款
     */
    REFUNDED: 'refunded',

    /**
     * 已取消
     */
    CANCELLED: 'cancelled',
    
    /**
     * 已过期
     */
    EXPIRED: 'expired',

    /**
     * 已失效
     */
    FAILED: 'failed'

};

export const plan = {

    ALL: 'all',
    
    /**
     * 有效套餐
     */
    ENABLED: 'enabled',

    /**
     * 无效套餐
     */
    DISABLED: 'disabled'

};



// WEBPACK FOOTER //
// ./src/config/status.js